import { http } from "@next-core/http";
/**
 * @description 批量导入业务对象实例数据（支持新增、更新、删除）
 * @endpoint POST /api/v1/elevo/objects/:objectId/instances/import
 */
export const ElevoObjectApi_importServiceObjectInstances = async (objectId, data, options) => /**! @contract easyops.api.llm.elevo_object.ImportServiceObjectInstances@1.0.0 */(await http.post(`api/gateway/logic.llm.aiops_service/api/v1/elevo/objects/${objectId}/instances/import`, data, options)).data;
//# sourceMappingURL=importServiceObjectInstances.js.map